<template>
    <div class="description">
        <slot></slot>
    </div>
</template>

<script>
export default {
    
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/content/elements/Description.vue